module.exports = __webpack_public_path__ + "img/price.d3565328.jpg";